export const H1 = '48px';
export const H2 = '32px';
export const H3 = '24px';
export const H4 = '20px';
export const H5 = '16px';
export const H6 = '14px';
export const H7 = '12px';
export const P1 = '14px';
export const P2 = '12px';

export const EXTRA_SMALL = '10px';
export const SMALL = '14px';
export const LARGE = '16px';

export const HEADER_LINE_HEIGHT = '150%';
export const PARA_LINE_HEIGHT = '120%';
export const BUTTON_LINE_HEIGHT = '100%';

export const BOLD = 'bold';
export const SEMIBOLD = '600';
export const REGULAR = 'normal';
